import React from 'react';

const About = () => {
  return (
    <div>
      <h1>About Us</h1>
      <p>This is the about page of your React application!</p>
    </div>
  );
}

export default About;